/* Pulipelo – panier latéral */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var el, fmt = '€{{amount_with_comma_separator}}', busy = false;
  var EB_HANDLE = 'guida-crescere-con-fiducia', EB_MIN = 2, ebVar = 0, syncing = false;
  /* option payante « Spedizione protetta » (case décochée par défaut) */
  var PR_HANDLE = 'spedizione-protetta', prVar = 0, prPrice = 399;
  function isEb(it) { return it && (it.handle === EB_HANDLE || (ebVar && it.variant_id === ebVar)); }
  function isPr(it) { return it && (it.handle === PR_HANDLE || (prVar && it.variant_id === prVar)); }
  function isExtra(it) { return isEb(it) || isPr(it); }
  var TIERS = [
    { n: 2, label: '1+1 IN OMAGGIO' },
    { n: 4, label: '2+2 IN OMAGGIO' }
  ];

  function q(s) { return el.querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) {
    cents = Math.round(cents || 0);
    var a = (cents / 100).toFixed(2), parts = a.split('.');
    var thou = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_with_comma_separator') return thou(parts[0], '.') + ',' + parts[1];
      if (k === 'amount_no_decimals') return thou(String(Math.round(cents / 100)), ',');
      if (k === 'amount_no_decimals_with_comma_separator') return thou(String(Math.round(cents / 100)), '.');
      return thou(parts[0], ',') + '.' + parts[1];
    });
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- option Spedizione protetta ---------- */
  var PR_STYLE = 'display:flex;align-items:flex-start;gap:10px;padding:10px 12px;margin:0 0 10px;border:1px solid #f0c9d6;border-radius:10px;background:#fff7fa;cursor:pointer;font-size:13px;line-height:1.35;text-align:left';
  function prBox(where) {
    return '<label class="bsc-prot" data-bsc-prot="' + where + '" style="' + PR_STYLE + '">' +
      '<input type="checkbox" data-bsc-prot-input style="margin-top:2px;width:18px;height:18px;flex:0 0 auto;accent-color:#e05a8a">' +
      '<span><b>🛡️ Spedizione protetta (+' + money(prPrice) + ')</b><br>Se il pacco si perde, arriva danneggiato o viene rubato, te lo rispediamo gratis.</span>' +
      '</label>';
  }
  function mountProt() {
    if (!prVar) return;
    var tot = el.querySelector('.bsc__row--total');
    if (tot && !el.querySelector('[data-bsc-prot="drawer"]')) tot.insertAdjacentHTML('beforebegin', prBox('drawer'));
    var pg = document.getElementById('BsCartPage');
    var pf = pg && pg.querySelector('.bscp__form');
    if (pf && !pg.querySelector('[data-bsc-prot="page"]')) pf.insertAdjacentHTML('afterbegin', prBox('page'));
  }
  function setShip(on) {
    var r = el.querySelector('.bsc__row--ship'); if (!r) return;
    var s = r.querySelector('span'), b = r.querySelector('b');
    if (s) s.textContent = on ? 'Spedizione protetta' : 'Spedizione';
    if (b) b.textContent = on ? money(prPrice) : 'GRATUITA';
  }
  function syncProtUI(cart) {
    var has = false, bra = 0;
    (cart.items || []).forEach(function (it) { if (isPr(it)) has = true; else if (!isEb(it)) bra += it.quantity; });
    document.querySelectorAll('[data-bsc-prot]').forEach(function (b) {
      b.style.display = bra ? 'flex' : 'none';
      var i = b.querySelector('[data-bsc-prot-input]'); if (i) i.checked = has;
    });
    setShip(has);
  }
  function toggleProt(on) {
    var c = el._cart; if (!c || !prVar) return;
    var has = (c.items || []).some(isPr); if (on === has) return;
    var t = money(c.total_price + (on ? prPrice : -prPrice));
    document.querySelectorAll('[data-bsc-total],[data-bscp-total]').forEach(function (x) { x.textContent = t; });
    document.querySelectorAll('[data-bsc-prot-input]').forEach(function (i) { i.checked = on; });
    setShip(on);
    var upd = {}; upd[prVar] = on ? 1 : 0;
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
      .then(function (r) { return r.json(); }).then(render)
      .catch(function () { load(); });
  }

  /* ---------- rendu ---------- */
  /* guida omaggio : 1 exemplaire dès EB_MIN produits, retiré en dessous ; option protégée : 1 max */
  function syncEbook(cart) {
    if (syncing) return;
    var bra = 0, eb = null, pr = null;
    (cart.items || []).forEach(function (it) { if (isEb(it)) eb = it; else if (isPr(it)) pr = it; else bra += it.quantity; });
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (pr && (!bra || pr.quantity > 1)) {
      syncing = true;
      fetch(root + 'cart/change.js', { method: 'POST', headers: h, body: JSON.stringify({ id: pr.key, quantity: bra ? 1 : 0 }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { syncing = false; render(c); })
        .catch(function () { syncing = false; });
      return;
    }
    var need = bra >= EB_MIN ? 1 : 0, have = eb ? eb.quantity : 0;
    if (need === have || (need && !ebVar)) return;
    syncing = true;
    var p = eb
      ? fetch(root + 'cart/change.js', { method: 'POST', headers: h, body: JSON.stringify({ id: eb.key, quantity: need }) })
      : fetch(root + 'cart/add.js', { method: 'POST', headers: h, body: JSON.stringify({ items: [{ id: ebVar, quantity: 1 }] }) });
    p.then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (c) { syncing = false; render(c); })
      .catch(function () { syncing = false; });
  }

  function ebookRow(it, page) {
    var cmp = it.variant_id === ebVar && el._ebCmp ? el._ebCmp : 1490;
    var price = '<s>' + money(cmp) + '</s><b class="bsc__gift">IN OMAGGIO</b>';
    if (page) return '<div class="bscp__item is-free is-ebook">' +
      '<span class="bscp__media"><img src="' + esc(img(it.image, 300)) + '" alt="' + esc(it.product_title) + '" loading="lazy"></span>' +
      '<div class="bscp__info"><span class="bscp__name">' + esc(it.product_title) + '</span>' +
      '<div class="bscp__unit"><s>' + money(cmp) + '</s> ' + money(0) + '</div>' +
      '<div class="bscp__badge"><span class="ms ms--fill">redeem</span>IN OMAGGIO</div></div>' +
      '<div class="bscp__tot"><s>' + money(cmp) + '</s><b>' + money(0) + '</b></div></div>';
    return '<div class="bsc__item is-free is-ebook">' +
      '<span class="bsc__thumbs"><img class="bsc__img" src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy"></span>' +
      '<div class="bsc__info"><div class="bsc__top"><span class="bsc__name">' + esc(it.product_title) + '</span></div>' +
      '<span class="bsc__badge"><span class="ms ms--fill">redeem</span>IN OMAGGIO</span>' +
      '<div class="bsc__bottom"><span></span><div class="bsc__price">' + price + '</div></div></div></div>';
  }

  function render(cart) {
    syncEbook(cart);
    var ebItem = null, count = 0, braOrig = 0;
    (cart.items || []).forEach(function (it) { if (isEb(it)) ebItem = it; else if (!isPr(it)) { count += it.quantity; braOrig += it.original_line_price; } });
    var cf = 1; el._cf = cf; el._cmpv = 0;
    q('[data-bsc-count]').textContent = '(' + count + ')';
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (b) { b.textContent = count; });
    var bubbleWrap = document.getElementById('cart-icon-bubble');
    if (bubbleWrap) {
      var bub = bubbleWrap.querySelector('.cart-count-bubble');
      if (!bub && count) { bubbleWrap.insertAdjacentHTML('beforeend', '<div class="cart-count-bubble"><span aria-hidden="true">' + count + '</span></div>'); }
      else if (bub && !count) bub.remove();
    }

    var empty = !count;
    q('[data-bsc-empty]').hidden = !empty;
    q('[data-bsc-progress]').hidden = empty;
    q('[data-bsc-foot]').hidden = empty;
    var rs = q('[data-bsc-reassure]'); if (rs) rs.hidden = empty;

    // barre de progression vers les offres
    var next = null; for (var i = 0; i < TIERS.length; i++) { if (count < TIERS[i].n) { next = TIERS[i]; break; } }
    var pct = Math.min(100, count / 4 * 100);
    q('[data-bsc-fill]').style.width = pct + '%';
    el.querySelectorAll('.bsc__step').forEach(function (s) { s.classList.toggle('is-done', count >= +s.dataset.step); });
    var miss = next ? next.n - count : 0;
    q('[data-bsc-ptext]').innerHTML = next
      ? 'Aggiungi ancora <b>' + miss + (miss === 1 ? ' confezione' : ' confezioni') + '</b> per sbloccare <b>' + esc(next.label) + '</b>'
      : '🎉 Complimenti! Hai sbloccato <b>2+2 IN OMAGGIO</b>';

    var items = cart.items || [];
    var offer = null;
    items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (d) { offer = offer || d.discount_application.title; }); });
    var m = offer && /(\d+)\s*\+\s*(\d+)/.exec(offer);
    var free = m ? Math.min(+m[2], count) : 0;
    var units = [];
    items.forEach(function (it, idx) { if (isExtra(it)) return; for (var u = 0; u < it.quantity; u++) units.push(idx); });
    var paidN = units.length - free;
    var groups = [];
    if (free) {
      groups.push({ free: false, units: units.slice(0, paidN) });
      groups.push({ free: true, units: units.slice(paidN) });
    } else {
      items.forEach(function (it, idx) { if (isExtra(it)) return; var us = []; for (var u = 0; u < it.quantity; u++) us.push(idx); groups.push({ free: false, units: us }); });
    }
    groups = groups.filter(function (g) { return g.units.length; });
    el._groups = groups;
    var prAmt = 0; items.forEach(function (it) { if (isPr(it)) prAmt += it.final_line_price; }); el._prAmt = prAmt;
    var html = '';
    groups.forEach(function (g, gi) {
      var first = items[g.units[0]], n = g.units.length;
      var orig = 0; g.units.forEach(function (ix) { orig += items[ix].original_price; });
      var cnt = {}, ord = [];
      g.units.forEach(function (ix) { var it = items[ix]; var k = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).reverse().join(' · '); if (!cnt[k]) { cnt[k] = 0; ord.push(k); } cnt[k]++; });
      var vlist = ord.filter(function (k) { return k; }).map(function (k) { return '<span class="bsc__var">' + (cnt[k] > 1 ? cnt[k] + '× ' : '') + esc(k) + '</span>'; }).join('');
      var priceHtml;
      if (g.free) priceHtml = '<s>' + money(orig) + '</s><b class="bsc__gift">IN OMAGGIO</b>';
      else if (free) { var sOrig = braOrig; var bt = cart.total_price - prAmt; priceHtml = (bt < sOrig ? '<s>' + money(sOrig) + '</s>' : '') + '<b>' + money(bt) + '</b>'; }
      else { var it0 = first; var fp = Math.round(it0.final_line_price); var ol = Math.round(it0.original_line_price); priceHtml = (fp < ol ? '<s>' + money(ol) + '</s>' : '') + '<b>' + money(fp) + '</b>'; }
      var imgs = []; g.units.forEach(function (ix) { var u = items[ix].image; if (u && imgs.indexOf(u) < 0) imgs.push(u); });
      var thumbs = '<span class="bsc__thumbs">' + imgs.slice(0, 1).map(function (u) { return '<img class="bsc__img" src="' + esc(img(u, 200)) + '" alt="' + esc(first.product_title) + '" loading="lazy">'; }).join('') + (imgs.length > 1 ? '<span class="bsc__more">+' + (imgs.length - 1) + '</span>' : '') + '</span>';
      html += '<div class="bsc__item' + (g.free ? ' is-free' : '') + '" data-g="' + gi + '">' +
        '<a href="' + esc(first.url) + '">' + thumbs + '</a>' +
        '<div class="bsc__info">' +
          '<div class="bsc__top"><a class="bsc__name" href="' + esc(first.url) + '">' + esc(first.product_title) + '</a>' +
          '<button type="button" class="bsc__del" data-bsc-act="del" aria-label="Rimuovi"><span class="ms">delete</span></button></div>' +
          (g.free ? '<span class="bsc__badge"><span class="ms ms--fill">sell</span>' + esc(offer) + '</span>' : '') +
          vlist +
          '<div class="bsc__bottom">' +
            '<div class="bsc__qty"><button type="button" data-bsc-act="minus" aria-label="Meno">−</button><span>' + n + '</span><button type="button" data-bsc-act="plus" aria-label="Più">+</button></div>' +
            '<div class="bsc__price">' + priceHtml + '</div>' +
          '</div>' +
        '</div></div>';
    });
    if (ebItem && count >= EB_MIN) html += ebookRow(ebItem, false);
    q('[data-bsc-items]').innerHTML = html;

    var save = (cart.original_total_price || 0) - (cart.total_price || 0);
    q('[data-bsc-saverow]').hidden = save <= 0;
    q('[data-bsc-save]').textContent = '−' + money(save);
    q('[data-bsc-total]').textContent = money(cart.total_price);
    el._cart = cart; el._free = free; el._offer = offer; el._eb = count >= EB_MIN ? ebItem : null;
    syncProtUI(cart);
    renderPage(cart);
  }

  /* ---------- page panier (/cart) ---------- */
  function renderPage(cart) {
    var pg = document.getElementById('BsCartPage'); if (!pg) return;
    var items = cart.items || [], groups = el._groups || [], offer = el._offer, free = el._free;
    var empty = !cart.item_count;
    pg.querySelector('[data-bscp-empty]').hidden = !empty;
    pg.querySelector('[data-bscp-list]').hidden = empty;
    pg.querySelector('[data-bscp-sum]').hidden = empty;
    var braOrig = 0; items.forEach(function (it) { if (!isExtra(it)) braOrig += it.original_line_price; });
    var h = '';
    groups.forEach(function (g, gi) {
      var first = items[g.units[0]], n = g.units.length, unit = first.original_price;
      var orig = 0; g.units.forEach(function (ix) { orig += items[ix].original_price; });
      var cnt = {}, ord = [];
      g.units.forEach(function (ix) { var it = items[ix]; var k = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.name + ': ' + o.value; }).join('|'); if (!cnt[k]) { cnt[k] = 0; ord.push(k); } cnt[k]++; });
      var vars = ord.filter(function (k) { return k; }).length === 0 ? '' : (ord.length === 1
        ? '<span class="bscp__var">' + ord[0].split('|').map(esc).join('<br>') + '</span>'
        : ord.map(function (k) { return '<span class="bscp__var">' + cnt[k] + '× ' + k.split('|').map(function (x) { return esc(x.split(': ')[1]); }).join(' · ') + '</span>'; }).join(''));
      var unitHtml, totHtml;
      if (g.free) { unitHtml = '<s>' + money(unit) + '</s> ' + money(0); totHtml = '<s>' + money(orig) + '</s><b>' + money(0) + '</b>'; }
      else if (free) { var sOrig = braOrig; var bt = cart.total_price - (el._prAmt || 0); unitHtml = money(unit); totHtml = (bt < sOrig ? '<s>' + money(sOrig) + '</s>' : '') + '<b>' + money(bt) + '</b>'; }
      else { var fp = Math.round(first.final_line_price); unitHtml = fp < first.original_line_price ? '<s>' + money(unit) + '</s> ' + money(first.final_price) : money(unit); var olp = Math.round(first.original_line_price); totHtml = (fp < olp ? '<s>' + money(olp) + '</s>' : '') + '<b>' + money(fp) + '</b>'; }
      h += '<div class="bscp__item' + (g.free ? ' is-free' : '') + '" data-g="' + gi + '">' +
        '<a class="bscp__media" href="' + esc(first.url) + '"><img src="' + esc(img(first.image, 300)) + '" alt="' + esc(first.product_title) + '" loading="lazy"></a>' +
        '<div class="bscp__info">' +
          '<a class="bscp__name" href="' + esc(first.url) + '">' + esc(first.product_title) + '</a>' +
          '<div class="bscp__unit">' + unitHtml + '</div>' + vars +
          (g.free && offer ? '<div class="bscp__badge"><span class="ms ms--fill">sell</span>' + esc(offer) + '</div>' : '') +
          '<div class="bscp__ctrl"><div class="bscp__qty"><button type="button" data-bsc-act="minus" aria-label="Meno">−</button><span>' + n + '</span><button type="button" data-bsc-act="plus" aria-label="Più">+</button></div>' +
          '<button type="button" class="bscp__del" data-bsc-act="del" aria-label="Rimuovi"><span class="ms">delete</span></button></div>' +
        '</div>' +
        '<div class="bscp__tot">' + totHtml + '</div>' +
      '</div>';
    });
    if (el._eb) h += ebookRow(el._eb, true);
    pg.querySelector('[data-bscp-items]').innerHTML = h;
    pg.querySelector('[data-bscp-total]').textContent = money(cart.total_price);
  }

  function load() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }

  function post(url, body) {
    if (busy) return; busy = true; el.classList.add('is-loading'); setPg(true);
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function () { busy = false; return load(); })
      .finally(function () { busy = false; el.classList.remove('is-loading'); setPg(false); });
  }
  function setPg(b) { var pg = document.getElementById('BsCartPage'); if (pg) pg.classList.toggle('is-loading', b); }
  function groupAct(g, act) {
    var c = el._cart; if (!g || !c) return;
    var lastIx = g.units[g.units.length - 1], it = c.items[lastIx];
    if (act === 'plus') return post('cart/add.js', { items: [{ id: it.variant_id, quantity: 1 }] });
    var upd = {};
    var take = act === 'minus' ? [lastIx] : g.units;
    take.forEach(function (ix) { var k = c.items[ix].key; upd[k] = (upd[k] == null ? c.items[ix].quantity : upd[k]) - 1; });
    return post('cart/update.js', { updates: upd });
  }

  function addOneMore() {
    var c = el._cart; if (!c || !c.items.length || busy) return;
    var bras = c.items.filter(function (it) { return !isExtra(it); }); if (!bras.length) return;
    var last = bras[bras.length - 1];
    busy = true; el.classList.add('is-loading');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: last.variant_id, quantity: 1 }] }) })
      .then(function () { busy = false; return load(); })
      .finally(function () { busy = false; el.classList.remove('is-loading'); });
  }

  function open() {
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bsc-lock');
    return load();
  }
  function close() {
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bsc-lock');
  }

  function init() {
    el = document.getElementById('BsCart'); if (!el) return;
    try { fmt = JSON.parse(el.querySelector('[data-bsc-money]').textContent) || fmt; } catch (e) {}
    try { var eb = JSON.parse(el.querySelector('[data-bsc-ebook]').textContent) || {}; ebVar = +eb.id || 0; el._ebCmp = +eb.cmp || 1490; if (eb.handle) EB_HANDLE = eb.handle; if (eb.min) EB_MIN = +eb.min; } catch (e) {}
    fetch(root + 'products/' + PR_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (!p || !p.variants || !p.variants.length) return; prVar = p.variants[0].id; prPrice = p.variants[0].price || prPrice; mountProt(); if (el._cart) syncProtUI(el._cart); })
      .catch(function () {});
    document.addEventListener('change', function (e) {
      var i = e.target.closest && e.target.closest('[data-bsc-prot-input]');
      if (i) toggleProt(i.checked);
    });
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bsc-close]')) { if (!t.closest('a[href]') || t.closest('.bsc__overlay,.bsc__x')) e.preventDefault(); close(); return; }
      var qb = t.closest('[data-bsc-act]');
      if (qb) { groupAct(el._groups[+qb.closest('[data-g]').dataset.g], qb.dataset.bscAct); return; }
      if (t.closest('[data-bsc-more]')) addOneMore();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"]');
      if (!a || el.contains(a) || document.getElementById('BsCartPage')) return;
      e.preventDefault(); e.stopImmediatePropagation(); open();
    }, true);
    var pg = document.getElementById('BsCartPage');
    if (pg) {
      pg.addEventListener('click', function (e) {
        var qb = e.target.closest('[data-bsc-act]');
        if (qb) { e.preventDefault(); groupAct(el._groups[+qb.closest('[data-g]').dataset.g], qb.dataset.bscAct); }
      });
      load();
    }
    window.BSCart = { open: open, close: close, refresh: load };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
